export default __webpack_public_path__ + "static/media/about1-s2-i1.3b351be6.png";